module.exports = __webpack_public_path__ + "img/author-empty-list-light.a2f5e1fb.svg";